import { useTranslation } from "@l2r-front/l2r-i18n"
import { useTheme } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../common/constants/i18n"

import { getRoadworkLegendConfig } from "../constants/getRoadworkConfig"

export function useRoadworksLegend() {

    const { t } = useTranslation(I18N_NAMESPACE)
    const theme = useTheme()

    return [
        {
            layerName: "roadworks",
            legendData: getRoadworkLegendConfig(t, theme),
            title: t(I18N_NAMESPACE, "containers.networkRoadwork.legend.title"),
        },
    ]
}